import { render, staticRenderFns } from "./CommodityAllocationListDetail.vue?vue&type=template&id=0335c95a&scoped=true"
import script from "./CommodityAllocationListDetail.vue?vue&type=script&lang=js"
export * from "./CommodityAllocationListDetail.vue?vue&type=script&lang=js"
import style0 from "./CommodityAllocationListDetail.vue?vue&type=style&index=0&id=0335c95a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0335c95a",
  null
  
)

export default component.exports